"use client"
import { useTheme } from "@mui/material/styles"
import { FC, HTMLAttributes, memo } from "react"
import { useTranslation } from "react-i18next"

import { Avatar, AvatarProps } from "../avatar"
import { NextImageProps } from "../image"

import styles from "./PostItemAuthor.module.scss"

import { create } from "@/helpers/bem"

const bem = create(styles, "PostItemAuthor")

export type PostItemAuthorAvatar = Omit<NextImageProps, "src" | "alt"> & {
  src?: string
  alt?: string
}

export type PostItemAuthorProps = {
  className?: string
  avatar?: PostItemAuthorAvatar
  avatarProps?: AvatarProps
  name?: string
  nameProps?: HTMLAttributes<HTMLParagraphElement>
}

export const PostItemAuthor: FC<PostItemAuthorProps> = memo(
  ({ className, avatar, avatarProps, name, nameProps }) => {
    const { t } = useTranslation()
    const theme = useTheme()
    const authorName = name ?? t("components.common.postItem.author.name")
    return (
      <div className={bem(undefined, undefined, className)}>
        <Avatar
          image={
            avatar?.src
              ? {
                  src: avatar?.src,
                  alt: avatar?.alt ?? "",
                }
              : undefined
          }
          {...avatarProps}
        />
        <p
          aria-label={`Author ${authorName}`}
          itemProp="author"
          {...nameProps}
          className={bem(
            "name",
            {
              [theme.palette.mode]: true,
            },
            nameProps?.className,
          )}
        >
          {authorName}
        </p>
      </div>
    )
  },
)

PostItemAuthor.displayName = "PostItemAuthor"
